import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token and current org id on every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nexora_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const orgId = localStorage.getItem("nexora_active_org_id");
  if (orgId) config.headers["X-Org-Id"] = orgId;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("nexora_token");
    }
    return Promise.reject(err);
  }
);

export default api;
